import { SelectOptionData } from '../../Pi/types'
import { CreateProductModel, EditProductModel, Product, ProductState } from './types'

export default abstract class ProductsCore {
  products: Array<Product>
  currencyList: Array<SelectOptionData>

  constructor(currencyList: Array<SelectOptionData>, products: Array<Product>) {
    this.products = products
    this.currencyList = currencyList
  }

  get activeProducts(): Array<Product> {
    return this.products.filter((p) => p.state === ProductState.Active)
  }

  get hiddenProducts(): Array<Product> {
    return this.products.filter((p) => p.state === ProductState.Hidden)
  }

  getSequenceNumber(id: number): number | null {
    const product = this.getProduct(id)

    if (product) {
      const products = product.state === ProductState.Active ? this.activeProducts : this.hiddenProducts

      const index = products.findIndex((i) => i.id === id)

      return index === -1 ? null : index + 1
    }
    return null
  }

  getProduct(id: number): Product | undefined {
    return this.products.find((p) => p.id === id)
  }

  restoreProductHandler(id: number): void {
    const product = this.getProduct(id)

    if (product) {
      this.restoreProduct(id).then(() => product.state = ProductState.Active)
    }
  }

  protected abstract restoreProduct(id: number): Promise<void>

  removeProductHandler(id: number): Promise<void> {
    return new Promise(resolve => {
      const index = this.products.findIndex((p) => p.id === id)

      if (index !== -1) {
        this.removeProduct(id).then((state) => {
          if (state === ProductState.Hidden) {
            this.products[index].state = ProductState.Hidden
          } else {
            this.products.splice(index, 1)
          }
        })
          .finally(() => resolve())
      } else {
        resolve()
      }
    })
  }

  protected abstract removeProduct(id: number): Promise<ProductState.Hidden | ProductState.Removed>

  editProductHandler(product: EditProductModel): Promise<void> {
    return new Promise(resolve => {
      const index = this.products.findIndex((p) => p.id === product.id)

      if (index !== -1) {
        this.editProduct(product)
          .then((product) => this.products.splice(index, 1, product))
          .finally(() => resolve())
      }
      resolve()
    })
  }

  protected abstract editProduct(product: EditProductModel): Promise<Product>

  createProductHandler(product: CreateProductModel): Promise<void> {
    return new Promise(resolve => {
      this.createProduct(product)
        .then((product) => this.products.unshift(product))
        .finally(() => resolve())
    })
  }

  protected abstract createProduct(product: CreateProductModel): Promise<Product>

  abstract getTargetId(): string
}
